<template>
  <MenuComponent
    :filtred_count="contentAllNotifications.length">
    <template #navbar="{ navbarMini }">
      <NavBar
        :active="activeMenuIndex"
        class="pt-5"
        :items="contentAllNotifications"
        :loading="loading"
        :mode="navbarMini"
        :show-count="false"
        :types="menuTypes"
        unload
        @filterItems="chooseType"/>
    </template>
    <template
      v-if="activeMenuType.type !== 'FROM_SMARTTENDER'"
      #filter>
      <sButton
        data-qa="check-all-viewed"
        icon="mail-open"
        small
        type="text"
        @click.stop="readAll">
        {{ $t('Notifications.AllNotificationsViewed') }}
      </sButton>
      <SearchInput
        class="mx-5"
        debounce
        :disabled="loading"
        :search.sync="filter.filter.searchText"
        :small="true"
        @input="search"/>
    </template>
    <template #items>
      <SmarttTenderNotifications
        v-if="activeMenuType.type === 'FROM_SMARTTENDER'"
        :loading.sync="loading"/>
      <template
        v-else-if="!loading">
        <sAlert
          v-if="loadingError"
          closable
          show-icon
          type="error">
          {{ $t('Common.ErrorTitle') }}
          <template slot="desc">
            {{ $t('Common.errorLoadingData') }}
          </template>
        </sAlert>
        <EmptyBlock
          v-if="!loading && (!contentAllNotifications || !contentAllNotifications.length || groups.every(group => !group.items.length))"
          data-qa="tenders-no-data"
          :text="no_notifications_text"/>
        <Groups
          v-else-if="!loading && groups.some(group => group.items.length)"
          ref="notifications_groups"
          can_expand
          class="pt-4 groups"
          content_class="pt-2 pb-2"
          :groups="groups"
          with_title>
          <template
            #title="{ group, index: groupIndex }">
            <div
              class="tender-title period-name h4-headline text-start"
              :data-qa="`item-${groupIndex}-name`">
              {{ group.title }}
            </div>
          </template>
          <template
            #content="{ group, index: groupIndex }">
            <EmptyBlock
              v-if="!group.items.length"
              data-qa="tenders-no-data"
              :text="no_notifications_text"/>
            <template v-else>
              <NotificationsGroupCard
                v-for="(entity, entityIndex) in group.items"
                :key="`group-${groupIndex}-${entity.subscriptionEntityId}`"
                :ref="`notification_card_${group.id}`"
                :data-qa="`item-${entityIndex}-table`"
                :entity="entity"
                :open="entityIndex === group.activeCard"
                :statuses="statuses"
                @update:open="group.activeCard=entityIndex"/>
            </template>
          </template>
        </Groups>
        <EmptyBlock
          v-else
          data-qa="tenders-no-data"
          :text="no_notifications_text"/>
      </template>
    </template>
    <template #loader>
      <sIcon
        v-if="loading && activeMenuType.group === 'com-organization'"
        class="align-self-center my-3"
        color="var(--white-color)"
        size="30"
        spin
        type="loading"/>
    </template>
  </MenuComponent>
</template>

<script>
import NavBar from 'components/common/blocks/NavBar.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import Groups from 'components/common/blocks/groups/Groups.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import SearchInput from 'components/common/inputs/SearchInput.vue'
import NotificationsGroupCard from 'components/notification/in-page/NotificationsGroupCard.vue'
import SmarttTenderNotifications from 'components/notification/smartTender/SmarttTenderNotifications.vue'

import { eventBus } from '@/main'
import NotificationApi from '@/api/notificationApi'
const notif_api = new NotificationApi()

import { innerChatMixin, storageMixin } from 'mixins'
import { mapGetters, mapActions } from 'vuex'

/**
 * @vue-data activeMenuIndex - Активная группа сообщений
 * @vue-data filterByType - фильтр для активной группы (подумать в computed)
 * @vue-data loading - признак загрузки
 * @vue-data menuTypes - пункты групп сообщений
 * @vue-data contentAllNotifications - все сообщения собранные по сущностям
 *
 * @vue-computed filterByTypes - отфильтрованные сообщения по выбранной группе
 * @vue-computed currentUser - текущий пользователь
 */
export default {
  name: 'notifications',
  mixins: [innerChatMixin, storageMixin],
  data() {
    return {
      activeMenuIndex: 0,
      filterByType: null,
      loading: true,
      loadingError: false,
      menuTypes: [
        {
          name: 'Notifications.FromSmarttender',
          type: 'FROM_SMARTTENDER',
          icon: 'star-outline',
          group: 'smarttender',
        },
        {
          name: 'Notifications.AllNotifications',
          type: 'ALL_NOTIFICATIONS',
          icon: 'category',
          group: 'com-organization',
        },
        {
          name: 'Notifications.ForMe',
          class: 'pl-7',
          type: 'FOR_ME',
          filter: el => {
            return el.bindingLevel === 'TENDER'
          },
          group: 'com-organization',
        },
        {
          name: 'Notifications.ForMyTenders',
          class: 'pl-7',
          type: 'FOR_MY_TENDERS',
          group: 'com-organization',
        }
      ],
      contentAllNotifications: [],
      groups: [],
      statuses: [],
      filter: {
        page: 1,
        size: 100,
        entityType: 'Tender',
        onlyMine: null, // null-все false-не мои true-только мои
        filter: {
          searchText: null,
          tagMe: null, // null-все false-не по мне true-только по мне
          unviewed: null,
        },
        exceptionEntityIds: [],
      }
    }
  },
  computed: {
    ...mapGetters('notification',['subscriptions','notifications','accessNotification','notificationEntities']),
    activeMenuType() {
      return this.menuTypes[this.activeMenuIndex]
    },
    no_notifications_text() {
      return !this.contentAllNotifications.length ?
        this.$t('Notifications.NoNotifications') : (this.filterByType === 'ALL_NOTIFICATIONS' ? this.$t('Notifications.NoNewNotifications') : this.$t('Notifications.NoResultsForSearch' ))
    },
  },
  methods: {
    ...mapActions('notification', ['addNotifications', 'getNotificationEntities' ]),
    /**
     * Изменение группы сообщений
     * доделать вызов внешнего api  с параметрами
     */
    chooseType(type) {
      if (type.group !== this.activeMenuType.group) {
        this.loading = true
      }
      const index = this.menuTypes.findIndex(i => i.type === type.type)
      if (index !== -1) {
        this.activeMenuIndex = index
        this.$_savePropToDBStorage('notificationPage_menuType', type.type)
        this.filterByType = type.type
        this.filter.filter.tagMe = type.type === 'FOR_ME' ? true : null
        this.filter.onlyMine = type.type === 'FOR_MY_TENDERS' ? true : null
      }
      if (type.group === 'com-organization') {
        this.getData()
      }
    },
    /**
     * Отмечаем все непрочитанные сообщения прочитанными
     */
    readAll() {
      let messages = []
      this.contentAllNotifications.forEach(item => item.messages.forEach(notification => {
        if (!notification.viewed) {
          messages.push(notification)
        }
      }))
      if (messages?.length) {
        this.$_changeViewedMessages(messages)
      }
    },
    search(testSerach) {
      this.filter.filter.searchText = testSerach ? testSerach : null
      if (this.activeMenuType.group === 'com-organization') {
        this.getData()
      }
    },
    getData() {
      this.loading = true
      this.loadingError = false
      const getSubscriptions = (model) => {
        const filter = {
          page: model.page,
          size: model.size,
          entityType: model.entityType,
          onlyMine: model.onlyMine,
          filter: {
            searchText: model.filter.searchText,
            tagMe: model.filter.tagMe,
            unviewed: model.filter.unviewed
          },
          exceptionEntityIds: []
        }
        return new Promise((resolve, reject) => {
          notif_api.getSubscriptions(filter)
            .then((result) => {
              this.filter.subscriptionEntityIds = Object.values(result.data.subscriptions).map(i => i.subscriptionEntityId)

              result.data.subscriptions.map((subscription) => {
                if (!this.subscriptions[subscription.entity.entityType][subscription.entity.entityId]) {
                  eventBus.$emit('UpdateEventSubscription', subscription )
                }
              })

              return resolve(result.data.subscriptions)
            })
            .catch((err) => {
              return reject(err)
            })
        })
      }

      const getNotifications = (model) => {
        const filter = {
          subscriptionEntityIds: model.subscriptionEntityIds,
          filter: {
            searchText: model.filter.searchText,
            tagMe: model.filter.tagMe,
            unviewed: model.filter.unviewed
          }
        }
        return new Promise((resolve, reject) => {
          notif_api.getNotifications(filter)
            .then((result) => {
              const notifications = []
              result.data.notifications.map(
                n => n.messages.map(
                  message => notifications.push({
                    subscriptionEntityId: n.subscriptionEntityId,
                    message: message
                  })
                )
              )
              this.addNotifications(notifications)
              return resolve(result.data.notifications)
            })
            .catch((err) => {
              return reject(err)
            })
        })
      }
      getSubscriptions(this.filter)
        .then(() => {
          getNotifications(this.filter).then((result) => {
            this.setModel(result)
          })
        })
        .catch(() => {
          this.loadingError = true
          this.loading = false
        })
    },
    refreshModel(items) {
      items.forEach((item) => {
        const subscriptionEntity = this.contentAllNotifications.find(i => i.subscriptionEntityId === item.subscriptionEntityId)
        if (subscriptionEntity) {
          item.messages.forEach((message) => {
            const messageItem = subscriptionEntity.messages.find(i => i.messageId === message.messageId)
            if (messageItem) { messageItem.viewed = true }
          })
        }
      })

      this.setModel()
    },
    setModel(notifications) {

      if (!notifications) {
        notifications = this.$_.cloneDeep(this.contentAllNotifications)
      }
      const getNotifications = (subscriptionEntityId) => {
        const resultSubscription = Object.values(this.subscriptions.Tender).find(i => i.subscriptionEntityId === subscriptionEntityId) || {}
        const result = {}
        resultSubscription.entity = {}
        if (resultSubscription.properties) {
          resultSubscription.properties.forEach((prop) => {
            result[prop.key] = prop.value
          })
        }
        return result
      }
      notifications = notifications.map(i => {
        return {
          ...i,
          entityProps: getNotifications(i.subscriptionEntityId)
        }
      })

      const result = notifications.map(i => ({
        ...i,
        lastDataSend: new Date(Math.max(
          ...i.messages.map(item => new Date(item.timestamp).getTime())
        ))
      }))
      this.$set(this, 'contentAllNotifications', Object.freeze(result))


      if (!result?.length ) {
        this.groups = []
      }
      this.groups = [
        {
          id: 0,
          activeCard: 0,
          title: this.$t('Notifications.NewNotifications'),
          items: result.filter(item => item.messages?.some(i => !i.viewed)).sort((a,b) => b.lastDataSend - a.lastDataSend),
        },
        {
          id: 1,
          activeCard: 0,
          title: this.$t('Notifications.ReadNotifications'),
          items: result.filter(item => item.messages?.every(i => i.viewed)).sort((a,b) => b.lastDataSend - a.lastDataSend),
        }
      ]
      this.loading = false
    }
  },
  async beforeDestroy() {
    if (this.accessNotification) {
      //this.$root.$off('newNotification', this.gotNotificationsList)
      this.loading = true
      this.$root.$off('UpdateEventsStatuses', this.refreshModel)
    }
  },
  async created() {
    if (this.accessNotification) {
      await this.$store.dispatch('setTenderStatuses', true).then(() => {
        this.statuses = this.$store.getters.getTenderAllStatuses
        this.$_getPropFromDBStorage('notificationPage_menuType', 0)
          .then((menuType) => {
            const index = this.menuTypes.findIndex(i => i.type == menuType)
            if (index !== -1) {
              this.activeMenuIndex = index
              this.chooseType(this.menuTypes[index])
            } else {
              this.activeMenuIndex = 0
              this.chooseType(this.menuTypes[0])
            }
            this.$root.$on('UpdateEventsStatuses', this.refreshModel)
          })
      })

    }
  },
  components: {
    NavBar,
    Groups,
    EmptyBlock,
    SearchInput,
    MenuComponent,
    NotificationsGroupCard,
    SmarttTenderNotifications,
  }
}
</script>
<style lang="scss" scoped>
.notification-entitie-card {
  margin-top: 10px;
  background: var(--v-main__light_green-base);
  border-radius: 8px;
}
.notification-entitie-title {
  display: flex;
  justify-content: space-between;
  height: 45px;
  padding: 10px 10px 10px 20px;
  border-radius: 8px 8px 0 0;
  text-decoration: underline !important;
  text-align: left;
  font-weight: 500;
}
</style>
